module.exports = __webpack_public_path__ + "img/blog-1.8231bd8f.jpg";